<div
  class="element-root-container cycle-row"
  [class.element-root-container--openable]="canOpenAlertLog()"
>
  <div class="cycle-row__when" (click)="onOpenAlertLog()">
    <span class="contact-name">{{ contact?.emergencyContactName }}</span>
    @if (contact?.selfPatient) {
      <span class="patient-badge">Alert Subject</span>
    }
  </div>
  <div class="cycle-row__info" (click)="onOpenAlertLog()">
    <p class="contact-line">{{ contactNumber }}</p>
    @for (line of progressLines(); track line) {
      <p class="contact-line contact-line--progress">{{ line }}</p>
    }
  </div>
  <div class="cycle-row__status">
    @if (!ongoing) {
      <div class="notify-button" (click)="notify()">
        <mat-icon class="call-icon">call</mat-icon> ALERT
      </div>
    } @else if (stopping) {
      <div class="notify-button stop-alert stop-alert--stopping" aria-busy="true">STOPPING…</div>
    } @else {
      <div class="notify-button stop-alert" (click)="cancelActiveAlert()">
        <mat-icon class="stop-icon">stop_circle</mat-icon> STOP
      </div>
    }
    <div class="menu-container">
      @if (!contact?.fromEpic && !contact?.selfPatient) {
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Contact actions">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          @if (ongoing) {
            <button mat-menu-item (click)="cancelActiveAlert()" [disabled]="stopping">
              <mat-icon class="stop-menu-icon">stop_circle</mat-icon>
              <span>{{ stopping ? 'Stopping…' : 'Stop Alert' }}</span>
            </button>
          }
          <button mat-menu-item (click)="edit()">
            <mat-icon>edit</mat-icon>
            <span>Edit Contact</span>
          </button>
          <button mat-menu-item class="warn" (click)="delete()">
            <mat-icon [color]="'warn'">delete_forever</mat-icon>
            <span>Delete Contact</span>
          </button>
        </mat-menu>
      }
    </div>
  </div>
</div>
